<button class="cart-button" (click)="inCheckoutPage() ? navigateToCart() : cartOP.toggle($event)">
  <i class="pi pi-shopping-cart"></i>
  <div class="total-quantity" *ngIf="cartQuantity">{{cartQuantity}}</div>
</button>
<p-overlayPanel #cartOP>
  <div class="cart-panel" *ngIf="cart">
    <div class="head">
      {{cartQuantity}} {{'navbar.cart.title' | translate}}
    </div>
    <div class="body">
      <div class="cart-item" *ngFor="let item of cart.products; let i = index;">
        <div class="data">
          <img [src]="item.icon" class="img-fluid" [alt]="item.name" />
          <div class="name">
            {{item.name}}
            <small class="quantity">{{'navbar.cart.quantity' | translate}} : {{item.quantity}}</small>
            <strong class="price">{{item.price | currency : item.currency}}</strong>
          </div>
        </div>
        <div class="action" *ngIf="!checkoutPageIsOpen()">
          <i class="pi pi-trash" (click)="removeItem(item, i)"></i>
        </div>
      </div>
      <div class="cart-is-empty text-center" *ngIf="!cartQuantity">{{'navbar.cart.emptyCart' | translate}}</div>
    </div>
    <div class="foot">
      <div class="total-price"><div class="label">{{'navbar.cart.total' | translate}} : </div> <div class="price">{{cart.total| currency : cart.currency}}</div></div>
      <button class="view-cart" (click)="navigate(appLanguage() + '/settings/cart')">{{'navbar.cart.viewCart' | translate}}</button>
      <button class="checkout" (click)="navigate(appLanguage() + '/checkout')">{{'navbar.cart.checkout' | translate}}</button>
    </div>
  </div>
</p-overlayPanel>